import { ComponentPropsWithoutRef, useState } from 'react';
import { cn } from 'v5/platform/dom/cn';

/**
 * An `<img>` that stays transparent until it has loaded, then fades in, instead
 * of popping in line by line. Key it by `src` to fade each new picture in.
 */
export function FadeInImage({
  className,
  onLoad,
  ...props
}: ComponentPropsWithoutRef<'img'>) {
  const [loaded, setLoaded] = useState(false);
  return (
    <img
      {...props}
      onLoad={event => {
        setLoaded(true);
        onLoad?.(event);
      }}
      className={cn(
        'transition-opacity duration-300 motion-reduce:transition-none',
        loaded ? 'opacity-100' : 'opacity-0',
        className
      )}
    />
  );
}
